const omission = '。'

export const truncateUntilPeriod = (text: string): string => {
  if (!text.includes(omission)) return text.slice(0, 30)

  return `${text.slice(0, text.slice(0, 80).lastIndexOf(omission))}${omission}`
}
